import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup} from '@angular/forms'
import { gutil} from '../../gutil';
import { Router} from "@angular/router";
import * as moment from 'moment';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { SessionService} from '../../services/session.service';

@Component({
  selector: 'app-update-profile',
  templateUrl: './update-profile.component.html',
  styleUrls: ['./update-profile.component.scss']
})

export class UpdateProfileComponent implements OnInit {
    public faUserCircle = faUserCircle;
    public user = {name:"",email:"", phone:"", gender:"", dob:"", emergencycontact:"",addressl1:"",city:"", state:"", nationality:"",father_name:"",mother_name:"", zipcode:"",adhaar_number:"", pan:"",occupation:"",off_email:"",off_address:"",off_name:"", off_city:"", off_state:"", off_zipcode:"", off_country:"",bank_ifsc:"",bank_account:""};
    public selectedCity: string;
    public genderSeluser: Array<any>;
    public citySel: Array<any>;
    public user_id: any;
    public minDOB:any;  
    public maxDOB:any; 
    public new_user:any;
    public form_msg:boolean = false;
    public form_success_msg:boolean = false;
    public form_submit_msg:any; 
    public userimage:any;
    public userData:Array<any>;

  
constructor(private http:HttpClient, private router: Router, private sessionservice : SessionService) { 

    this.citySel = gutil.citySel;
    this.genderSeluser = gutil.genderSeluser;

}

ngOnInit(): void {
    this.new_user = gutil.user;
    this.user.name = this.new_user.name;
    this.user.phone = this.new_user.phone;
    this.user.email = this.new_user.email;
    this.user.city = "city";
    this.user.dob = "Date of Birth";
    this.user.gender = "gender";
    this.minDOB = moment().subtract(120, "years").format("YYYY-MM-DD");
    this.maxDOB = moment().subtract(16, 'years').format("YYYY-MM-DD");
}

// form fields defined here
public onNameChange(value: any) {
    this.user.name = value;
}
public onChangeEmail(value: any) {
    this.user.email = value;
}
public onChangeFatherName(value: any) {
    this.user.father_name = value;
}
public onChangeMotherName(value: any) {
    this.user.mother_name = value;
}
public onChangePhone(value:any) {
    this.user.phone = value;
}
public onChangeEmergencyContact(value:any) {
    this.user.emergencycontact = value;
}
public onChangeAddress(value: any) {
    this.user.addressl1 = value;
}
public onChangeState(value: any) {
    this.user.state = value;
}
public onChangeZipcode(value: any) {
    this.user.zipcode = value;
}
public onChangeCity(value: any) {
    this.user.city = value;
}
public onChangeAdharNumber(value: any) {    
    if(value.toString().length == 12) {        
        this.user.adhaar_number = value;        
    }    
    else 
        this.user.adhaar_number = "";        
}
public onChangePan(value: any) {
    this.user.pan = value;
}
public onChangeOccupation(value: any) {
    this.user.occupation = value;
}
public onChangeNationality(value: any) {
    this.user.nationality = value;
}
public onGenderChange(value: any) {
    this.user.gender = value;
}

public onDOBChange(value: any) {
    this.user.dob = value;
}
// //Fields for Professional details defined here
public onChangeOffEmail(value: any) {
    this.user.off_email = value;
}
public onChangeOffName(value: any) {
    this.user.off_name = value;
}
public onChangeOffAddress(value: any) {
    this.user.off_address = value;
}
public onChangeOffCity(value: any) {
    this.user.off_city = value;
}
public onChangeOffState(value: any) {
    this.user.off_state = value;
}
public onChangeOffCountry(value: any) {
    this.user.off_country = value;
}
public onChangeOffZipcode(value: any) {
    this.user.off_zipcode = value;
}    
public onChangeBankIfsc(value: any) {
    this.user.bank_ifsc = value;
}
public onChangeBankAccount(value: any) {
    this.user.bank_account = value;
}

public editProfile() {
    if(this.user.name!="" && this.user.email!="" && this.user.phone!="" && this.user.father_name!="" && 
        this.user.mother_name!="" && this.user.addressl1!="" && this.user.zipcode!="" && this.user.city!="" && 
        this.user.state!="" && this.user.gender!="" && this.user.occupation!="" && this.user.nationality!="" &&
        this.user.adhaar_number!="" && this.user.bank_account!="" && this.user.bank_ifsc!="" && this.user.dob!= ""&&
        this.user.off_name!="" && this.user.off_email!=""&& this.user.off_state!="" && this.user.off_city!="" &&
        this.user.off_address!="" && this.user.off_country!="" )
        {
            
            let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
            let options =  {headers: headers };
            let params = new URLSearchParams();
            let vdate:any;

            for (let key in this.user) {
                if(key == "dob" && this.user[key] != null){
                    vdate = new Date(this.user[key]);
                    params.append(key, gutil.getDate(vdate));
                }
                else if(key == "images" && this.userimage != undefined){
                    // this.onUserImageUpload(this.user_id);
                }
                else if(key == "images" || key == "imgUrl" || key == "updated_at" || key == "api_token"){
                    continue;
                }
                else{
                    params.append(key, this.user[key]);
                }
            }
            let paramsString = params.toString();
            
            
            let result = this.http.post(gutil.devapiUrl + '/api/v1/user/edit/' + this.new_user.id + '?api_token=' + this.new_user.api_token,paramsString, options)    
                .subscribe((data:any) => {
                    this.form_success_msg = true;
                    this.form_submit_msg = "Thank You! Your Profile has been updated"
                    this.clearNotfMsg();
                    this.sessionservice.setUser(data.obj);
                    setTimeout(() => {
                        this.router.navigate(['/roomalloc/']);
                    }, 3000)
                });            
        }
        else {
            this.form_msg = true;
            this.form_submit_msg = "All Fields Mandatory";
            this.clearNotfMsg();
        }
}

public onUserImageUpload(value:any) {
    this.userimage = value.target.files;
    
    // this.readURL(value.target.files);
}
public clearNotfMsg() {
    setTimeout(() => {
        this.form_msg = false;
    }, 3000)
}
} 


